<template>
    <div class="d-inline-block">
        <button class="btn btn-primary" type="submit" @click.prevent="handleModal" ref="buttonRef">
            <slot></slot>
        </button>

        <Modal :title="title" :show="showModal" @close="showModal=false">
            <p v-html="dynamicMessage"></p>
            <button class="btn btn-primary" type="submit" @click.prevent="handleSubmit" ref="submitRef">Submit</button>
            <button class="btn btn-link" @click.prevent="showModal=false">Close</button>
        </Modal>
    </div>
</template>

<script>
import Modal from "./Modal";

export default {
    name: "SubmitModal",
    props: {
        title: { type: String, default: 'Attention', required: false },
        message: { type: String, default: '', required: false },
    },
    components: {
        Modal,
    },
    data() {
        return {
            showModal: false,
            dynamicMessage: '',
        };
    },
    methods: {
        handleModal() {
            const brandAccessChecked = document.querySelectorAll("input[name='brand_access[]']:checked").length > 0;
            const countriesChecked = document.querySelectorAll("input[name='countries[]']:checked").length > 0;

            if (document.querySelector('[name="role"]:checked')?.value != 1 && (!brandAccessChecked || !countriesChecked)) {
                if (!brandAccessChecked && !countriesChecked) {
                    this.dynamicMessage = this.message.replace(':items', 'countries and brands');
                } else if (!brandAccessChecked) {
                    this.dynamicMessage = this.message.replace(':items', 'brands');
                } else if (!countriesChecked) {
                    this.dynamicMessage = this.message.replace(':items', 'countries');
                }

                this.showModal = true;
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.submitRef.focus();
                    });
                });

                return;
            }

            this.$refs.buttonRef.closest('form').submit();
        },
        handleSubmit() {
            this.showModal = false;
            this.$refs.buttonRef.closest('form').submit();
        }
    },
}
</script>